var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ag-grid-vue", {
        key: "gridPreventiva",
        staticClass: "ag-theme-material",
        staticStyle: {
          width: "100%",
          height: "400px",
          "font-family": "'Asap', sans-serif"
        },
        attrs: {
          columnDefs: _vm.columnDefsPreventivas,
          rowData: _vm.preventivasRespaldo,
          rowSelection: "multiple",
          rowMultiSelectWithClick: "false",
          pagination: "true",
          paginationPageSize: "10",
          suppressRowClickSelection: "true",
          rowHeight: "35",
          headerHeight: "45",
          sideBar: _vm.sideBar,
          localeText: _vm.localeText,
          onGridReady: _vm.onGridReadyPreventivas,
          suppressCsvExport: true,
          suppressExcelExport: true,
          processCellForClipboard: _vm.procesarFecha
        }
      }),
      _vm.mostrarModalVerDetalle
        ? _c("VerDetallePlanPreventivoModal", {
            attrs: { planSeleccionado: _vm.planSeleccionado },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }